import React from 'react';

import { NotificationContextType } from './types';

export const NotificationContext = React.createContext<NotificationContextType>({} as NotificationContextType);
